const $body = $('body'),
    $masthead = $('header.masthead');

// when a link is clicked with href attribute starting with #, scroll that shit smoothly (if target exists)
$body.on('click', 'a[href^="#"]', function() {
    let $this = $(this);
    let target = $(this).attr('href');
    let scrollOffset = $masthead.outerHeight();

    // check if target is more than just a # dummy link
    if (target.length > 1) {

        // check if target is a complete url instead of only #id, if so, extract ID part
        if (!target.startsWith('#')) {
            target = '#'+ target.split('#').pop();
        }

        if ( $this.data('extra-scroll-offset') ) {
            scrollOffset = scrollOffset + $(this).data('extra-scroll-offset');
        }

        // if target exists
        if ( $(target).length > 0 ) {

            // if target has top margin, add half of it to scroll offset
            let targetMargin = parseInt($(target).css('marginTop'));

            if (targetMargin > 0) {
                scrollOffset = scrollOffset + (targetMargin / 2);
            }

            $('html, body').stop().animate({
                scrollTop: $(target).offset().top - scrollOffset
            }, 1000, 'easeInOutCubic').promise().done(function () {
                $this.blur();
            });
        }
    }
});